const Batch = {
  queryList: [
    {
      name: 'auditYear',
      label: '送审年份',
      notNull: true,
      component: 'select',
      request: {
        method: 'post',
        addr: '/school/schoolQuarter/getSchoolYearList',
        data: {},
        format: {
          value: 'auditYear',
          label: 'auditYear'
        }
      }
    }
  ],
  urlMap: {
    select: {
      url: '/school/schoolBatch/list',
      data: {
        sendType: '{default.sendType}'
      }
    },
    update: '/school/schoolBatch/saveOrUpdate',
    delete: '/school/schoolBatch/delete/{id}'
  },
  operList: [// 操作列表
    {
      name: 'add',
      label: '新增',
      show: true,
      action: {
        type: 'dialog',
        addr: 'allAuthorize/fuBatchConfigEdit?{default.sendType}'
      }
    }
  ],
  titles: [
    {
      name: 'auditYear',
      label: '送审年份'
    },
    {
      name: 'seasonName',
      label: '送审季度'
    },
    {
      name: 'name',
      label: '批次'
    },
    {
      name: 'sendTypeName',
      label: '送审方式'
    },
    {
      name: 'reviewEndTime',
      label: '论文评阅截止时间'
    },
    {
      name: 'operation',
      label: '操作',
      actionList: [
        {
          label: '编辑',
          name: 'edit',
          width: 800,
          kind: 'primary', // error
          type: 'dialog', // request, router, dialog, func
          addr: 'allAuthorize/fuBatchConfigEdit?{default.sendType}_{id}'
        },
        {
          label: '删除',
          kind: 'primary',
          type: 'request',
          addr: 'delete',
          data: '{id}',
          confirm: {
            desc: '确认删除？'
          }
        }
      ]
    }
  ]
}
export default Batch



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/allAuthorize/fuBatchConfig.js